export const LEGAL_FORM_TYPE_OPTIONS = [
  { value: '-', text: 'Unknown' },
  { value: 'A', text: 'Private Limited' },
  { value: 'B', text: 'Public Limited' },
  { value: '1', text: 'A' },
  { value: '2', text: 'a.m.ba' },
  { value: '3', text: 'a.s' },
  { value: '4', text: 'AA' },
  { value: '5', text: 'AAM' },
  { value: '6', text: 'AB' },
  { value: '7', text: 'ACE' },
  { value: '8', text: 'AD' },
  { value: '9', text: 'ADSIC' },
  { value: '10', text: 'AG' },
  // TODO update text
  { value: '11', text: '11' },
  { value: '12', text: '12' },
  { value: '13', text: '13' },
  { value: '14', text: '14' },
  { value: '15', text: '15' },
  { value: '16', text: '16' },
  { value: '18', text: '18' },
  { value: '19', text: '19' },
  { value: '20', text: '20' },
  { value: '21', text: '21' },
  { value: '22', text: '22' },
  { value: '23', text: '23' },
  { value: '24', text: '24' },
  { value: '25', text: '25' },
  { value: '26', text: '26' },
  { value: '27', text: '27' },
  { value: '28', text: '28' },
  { value: '29', text: '29' },
  { value: '30', text: '30' },
  { value: '31', text: '31' },
  { value: '32', text: '32' },
  { value: '33', text: '33' },
  { value: '34', text: '34' },
  { value: '35', text: '35' },
  { value: '36', text: '36' },
  { value: '37', text: '37' },
  { value: '38', text: '38' },
  { value: '39', text: '39' },
  { value: '40', text: '40' },
  { value: '41', text: '41' },
  { value: '42', text: '42' },
  { value: '43', text: '43' },
  { value: '44', text: '44' },
  { value: '45', text: '45' },
  { value: '46', text: '46' },
  { value: '47', text: '47' },
  { value: '48', text: '48' },
  { value: '49', text: '49' },
  { value: '50', text: '50' },
  { value: '51', text: '51' },
  { value: '52', text: '52' },
  { value: '53', text: '53' },
  { value: '54', text: '54' },
  { value: '55', text: '55' },
  { value: '56', text: '56' },
  { value: '57', text: '57' },
  { value: '58', text: '58' },
  { value: '59', text: '59' },
  { value: '60', text: '60' },
  { value: '61', text: '61' },
  { value: '62', text: '62' },
  { value: '63', text: '63' },
  { value: '64', text: '64' },
  { value: '65', text: '65' },
  { value: '66', text: '66' },
  { value: '67', text: '67' },
  { value: '68', text: '68' },
  { value: '69', text: '69' },
  { value: '70', text: '70' },
  { value: '71', text: '71' },
  { value: '72', text: '72' },
  { value: '73', text: '73' },
  { value: '74', text: '74' },
  { value: '75', text: '75' },
  { value: '76', text: '76' },
  { value: '77', text: '77' },
  { value: '78', text: '78' },
  { value: '79', text: '79' },
  { value: '80', text: '80' },
  { value: '81', text: '81' },
  { value: '82', text: '82' },
  { value: '83', text: '83' },
  { value: '84', text: '84' },
  { value: '85', text: '85' },
  { value: '86', text: '86' },
  { value: '87', text: '87' },
  { value: '88', text: '88' },
  { value: '89', text: '89' },
  { value: '90', text: '90' },
  { value: '91', text: '91' },
  { value: '92', text: '92' },
  { value: '93', text: '93' },
  { value: '94', text: '94' },
  { value: '95', text: '95' },
  { value: '96', text: '96' },
  { value: '97', text: '97' },
  { value: '98', text: '98' },
  { value: '99', text: '99' },
  { value: '100', text: '100' },
  { value: '101', text: '101' },
  { value: '102', text: '102' },
  { value: '103', text: '103' },
  { value: '104', text: '104' },
  { value: '105', text: '105' },
  { value: '106', text: '106' },
  { value: '107', text: '107' },
  { value: '108', text: '108' },
  { value: '109', text: '109' },
  { value: '110', text: '110' },
  { value: '111', text: '111' },
  { value: '112', text: '112' },
  { value: '113', text: '113' },
  { value: '114', text: '114' },
  { value: '115', text: '115' },
  { value: '116', text: '116' },
  { value: '117', text: '117' },
  { value: '118', text: '118' },
  { value: '119', text: '119' },
  { value: '120', text: '120' },
  { value: '121', text: '121' },
  { value: '122', text: '122' },
  { value: '123', text: '123' },
  { value: '124', text: '124' },
  { value: '125', text: '125' },
  { value: '126', text: '126' },
  { value: '127', text: '127' },
  { value: '128', text: '128' },
  { value: '129', text: '129' },
  { value: '130', text: '130' },
  { value: '131', text: '131' },
  { value: '132', text: '132' },
  { value: '133', text: '133' },
  { value: '134', text: '134' },
  { value: '135', text: '135' },
  { value: '136', text: '136' },
  { value: '137', text: '137' },
  { value: '138', text: '138' },
  { value: '139', text: '139' },
  { value: '140', text: '140' },
  { value: '141', text: '141' },
  { value: '142', text: '142' },
  { value: '143', text: '143' },
  { value: '144', text: '144' },
  { value: '145', text: '145' },
  { value: '146', text: '146' },
  { value: '147', text: '147' },
  { value: '148', text: '148' },
  { value: '149', text: '149' },
  { value: '150', text: '150' },
  { value: '151', text: '151' },
  { value: '152', text: '152' },
  { value: '153', text: '153' },
  { value: '154', text: '154' },
  { value: '155', text: '155' },
  { value: '156', text: '156' },
  { value: '157', text: '157' },
  { value: '158', text: '158' },
  { value: '159', text: '159' },
  { value: '160', text: '160' },
  { value: '161', text: '161' },
  { value: '162', text: '162' },
  { value: '163', text: '163' },
  { value: '164', text: '164' },
  { value: '165', text: '165' },
  { value: '166', text: '166' },
  { value: '167', text: '167' },
  { value: '168', text: '168' },
  { value: '169', text: '169' },
  { value: '170', text: '170' },
  { value: '171', text: '171' },
  { value: '172', text: '172' },
  { value: '173', text: '173' },
  { value: '174', text: '174' },
  { value: '175', text: '175' },
  { value: '176', text: '176' },
  { value: '177', text: '177' },
  { value: '178', text: '178' },
  { value: '179', text: '179' },
  { value: '180', text: '180' },
  { value: '181', text: '181' },
  { value: '182', text: '182' },
  { value: '183', text: '183' },
  { value: '184', text: '184' },
  { value: '185', text: '185' },
  { value: '186', text: '186' },
  { value: '187', text: '187' },
  { value: '188', text: '188' },
  { value: '189', text: '189' },
  { value: '190', text: '190' },
  { value: '191', text: '191' },
  { value: '192', text: '192' },
  { value: '193', text: '193' },
  { value: '194', text: '194' },
  { value: '195', text: '195' },
  { value: '196', text: '196' },
  { value: '197', text: '197' },
  { value: '198', text: '198' },
  { value: '199', text: '199' },
  { value: '200', text: '200' },
  { value: '201', text: '201' },
  { value: '202', text: '202' },
  { value: '203', text: '203' },
  { value: '204', text: '204' },
  { value: '205', text: '205' },
  { value: '206', text: '206' },
  { value: '207', text: '207' },
  { value: '208', text: '208' },
  { value: '209', text: '209' },
  { value: '210', text: '210' },
  { value: '211', text: '211' },
  { value: '212', text: '212' },
  { value: '213', text: '213' },
  { value: '214', text: '214' },
  { value: '215', text: '215' },
  { value: '216', text: '216' },
  { value: '217', text: '217' },
  { value: '218', text: '218' },
  { value: '219', text: '219' },
  { value: '220', text: '220' },
  { value: '221', text: '221' },
  { value: '222', text: '222' },
  { value: '223', text: '223' },
  { value: '224', text: '224' },
  { value: '225', text: '225' },
  { value: '226', text: '226' },
  { value: '227', text: '227' },
  { value: '228', text: '228' },
  { value: '229', text: '229' },
  { value: '230', text: '230' },
  { value: '231', text: '231' },
  { value: '232', text: '232' },
  { value: '233', text: '233' },
  { value: '234', text: '234' },
  { value: '235', text: '235' },
  { value: '236', text: '236' },
  { value: '237', text: '237' },
  { value: '238', text: '238' },
  { value: '239', text: '239' },
  { value: '240', text: '240' },
  { value: '241', text: '241' },
  { value: '242', text: '242' },
  { value: '243', text: '243' },
  { value: '244', text: '244' },
  { value: '245', text: '245' },
  { value: '246', text: '246' },
  { value: '247', text: '247' },
  { value: '248', text: '248' },
  { value: '249', text: '249' },
  { value: '250', text: '250' },
  { value: '251', text: '251' },
  { value: '252', text: '252' },
  { value: '253', text: '253' },
  { value: '254', text: '254' },
  { value: '255', text: '255' },
  { value: '256', text: '256' },
  { value: '257', text: '257' },
  { value: '258', text: '258' },
  { value: '259', text: '259' },
  { value: '260', text: '260' },
  { value: '261', text: '261' },
  { value: '262', text: '262' },
] as const;

export type LegalFormType =
  | (typeof LEGAL_FORM_TYPE_OPTIONS)[number]['value']
  | '';
